import '../plugins/SlickCarouselPlugin.js';

// mobile menu init
export default function initSlickCarousel() {
	jQuery('.video-gallery').each(function() {
		var gallery = jQuery(this);
		var videos = jQuery();
		var videosLoaded = false;

		gallery.on('init', function(e, slick, currentIndex, nextIndex) {
			videos = slick.$slider.find('video')

			// init players
			$('.play-video').on('click', function(e) {
				e.preventDefault();
				if (!videosLoaded) {
					$(this).closest('.media-holder').addClass('do-play');
					initMediaelementPlayer(videos);
					videosLoaded = true;
				}
			})
		})
		.on('init beforeChange', function(e, slick, currentIndex, nextIndex) {
			// pause videos
			videos.each(function () {
				var video = jQuery(this);
				var videoApi = video.data('playerApi');

				if (videoApi && !videoApi.paused) {
					videoApi.pause();
				}
			});
		})
		.on('afterChange', function(e, slick, currentIndex, nextIndex) {
			var autoplayVideo = slick.$slides.eq(currentIndex).find('.bg-video-el, .autoplay');

			// play bg video
			autoplayVideo.each(function() {
				var video = jQuery(this);
				var videoApi = video.data('playerApi');

				if (videoApi && videoApi.paused) {
					videoApi.play();
				}
			});
		})
		.on('click', '.slick-next', function(e) {
			e.preventDefault();
			gallery.slick('slickNext');
		})
		.on('click', '.slick-prev', function(e) {
			e.preventDefault();
			gallery.slick('slickPrev');
		});

		gallery.slick({
			slidesToScroll: 1,
			rows: 0,
			slidesToShow: 1,
			appendArrows: gallery.data('append-arrows') ? gallery.find('.media-holder') : gallery,
			prevArrow: '<button class="slick-prev ti-angle-left"></button>',
			nextArrow: '<button class="slick-next ti-angle-right"></button>'
		});
	});

	$('.view-section a[data-toggle="tab"]').on('shown.bs.tab', function(e) {
		// reposition the sliders on tab opening
		$('.video-gallery, .view-slider-single, .view-slider').slick('setPosition');
	});

	jQuery('.view-slider').slick({
		slidesToScroll: 1,
		slidesToShow: 3,
		infinite: true,
		dots: true,
		dotsClass: 'slick-dots',
		rows: 0,
		prevArrow: '<button class="slick-prev ti-angle-left"></button>',
		nextArrow: '<button class="slick-next ti-angle-right"></button>',
		responsive: [{
			breakpoint: 992,
			settings: {
				slidesToShow: 2
			}
		}, {
			breakpoint: 768,
			settings: {
				slidesToShow: 1
			}
		}]
	});

	jQuery('.logo-slider').slick({
		slidesToScroll: 1,
		slidesToShow: 4,
		centerMode: true,
		infinite: true,
		rows: 0,
		prevArrow: '<button class="slick-prev ti-angle-left"></button>',
		nextArrow: '<button class="slick-next ti-angle-right"></button>',
		responsive: [{
			breakpoint: 992,
			settings: {
				slidesToShow: 2
			}
		}, {
			breakpoint: 768,
			settings: {
				slidesToShow: 1
			}
		}]
	});

	jQuery('.logo-slider-autoplay').slick({
		slidesToScroll: 1,
		slidesToShow: 4,
		centerMode: true,
		infinite: true,
		rows: 0,
		prevArrow: '<button class="slick-prev ti-angle-left"></button>',
		nextArrow: '<button class="slick-next ti-angle-right"></button>',
		responsive: [{
			breakpoint: 992,
			settings: {
				slidesToShow: 2
			}
		}, {
			breakpoint: 768,
			settings: {
				slidesToShow: 1
			}
		}],
		autoplay: true,
		autoplaySpeed: 2000,
	});

	jQuery('.view-slider-single').slick({
		slidesToScroll: 1,
		slidesToShow: 1,
		infinite: true,
		rows: 0,
		prevArrow: '<button class="slick-prev ti-angle-left"></button>',
		nextArrow: '<button class="slick-next ti-angle-right"></button>',
	});

	jQuery('.project-slider').slick({
		slidesToScroll: 1,
		slidesToShow: 2,
		infinite: true,
		dots: false,
		dotsClass: 'slick-dots',
		rows: 0,
		prevArrow: '<button class="slick-prev ti-angle-left"></button>',
		nextArrow: '<button class="slick-next ti-angle-right"></button>',
		responsive: [{
			breakpoint: 992,
			settings: {
				slidesToShow: 1
			}
		}]
	});

	jQuery('.events-slider').slick({
		slidesToScroll: 1,
		slidesToShow: 2,
		infinite: true,
		dots: true,
		dotsClass: 'slick-dots',
		rows: 0,
		prevArrow: '<button class="slick-prev ti-angle-left"></button>',
		nextArrow: '<button class="slick-next ti-angle-right"></button>',
		responsive: [{
			breakpoint: 992,
			settings: {
				slidesToShow: 1
			}
		}]
	});

  //   jQuery('.events-slider').slick({
	// 	slidesToScroll: 1,
	// 	slidesToShow: 1,
	// 	rows: 0,
	// 	prevArrow: '<button class="slick-prev ti-angle-left"></button>',
	// 	nextArrow: '<button class="slick-next ti-angle-right"></button>'
	// });

	jQuery('.product-visual-slider').slick({
		slidesToScroll: 1,
		slidesToShow: 1,
		rows: 0,
		prevArrow: '<button class="slick-prev" aria-label="button prev"><svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.03516 6.28516L6.28516 1.0625C6.53125 0.789062 6.94141 0.789062 7.21484 1.0625C7.46094 1.30859 7.46094 1.71875 7.21484 1.96484L2.40234 6.75L7.1875 11.5625C7.46094 11.8086 7.46094 12.2188 7.1875 12.4648C6.94141 12.7383 6.53125 12.7383 6.28516 12.4648L1.03516 7.21484C0.761719 6.96875 0.761719 6.55859 1.03516 6.28516Z" fill="#112277"/></svg></button>',
		nextArrow: '<button class="slick-next" aria-label="button next"><svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.96484 6.28516C7.21094 6.55859 7.21094 6.96875 6.96484 7.21484L1.71484 12.4648C1.44141 12.7383 1.03125 12.7383 0.785156 12.4648C0.511719 12.2188 0.511719 11.8086 0.785156 11.5625L5.57031 6.77734L0.785156 1.96484C0.511719 1.71875 0.511719 1.30859 0.785156 1.0625C1.03125 0.789062 1.44141 0.789062 1.6875 1.0625L6.96484 6.28516Z" fill="#112277"/></svg></button>'
	});

	const sliderCardsConfig = {
		slidesToScroll: 1,
		slidesToShow: 1,
		arrows: false,
		rows: 0,
		infinite: false,
		variableWidth: true
	};
	jQuery('.slider-cards').slick(sliderCardsConfig);

}
